import './AssetStats.scss'
import {useSelector} from "react-redux";
import {getAssetIds, getIsSingleAsset} from "../../../ducks/assets-duck.js";
import {getUpdateKey} from "../../../ducks/chart-duck.js";
import AssetKPIs from "./AssetKPIs.jsx";
import AssetUrls from "./AssetUrls.jsx";
import StatLine from "./StatLine.jsx";
import OffloadingGauge from "./OffloadingGauge.jsx";
import AssetCompositionBar from "./AssetCompositionBar.jsx";
import RateTrajectory from "./RateTrajectory.jsx";
import LiveChart from "./live-chart/LiveChart.jsx";

export default () => {

    const assetIds = useSelector(getAssetIds)
    const isSingleAsset = useSelector(getIsSingleAsset)
    const updateKey = useSelector(getUpdateKey)

    return (
        <div className='asset-stats' key={updateKey}>
            <StatLine/>
            <AssetKPIs/>
            {isSingleAsset && <LiveChart assetId={assetIds[0]}/>}
            <AssetUrls/>
            {isSingleAsset && <OffloadingGauge/>}
            {isSingleAsset && <RateTrajectory/>}
            {!isSingleAsset && <AssetCompositionBar/>}
            {/*<div className={`ath-barometers ${isRateCardVisible ? 'reduced-gap' : ''}`}>*/}
            {/*    <AllTimeHighBarometer*/}
            {/*        currentValue={totalValue}*/}
            {/*        athValue={maxValue}*/}
            {/*        athDate={maxValueDate}*/}
            {/*    >*/}
            {/*        Value ATH*/}
            {/*    </AllTimeHighBarometer>*/}
            {/*    <AllTimeHighBarometer*/}
            {/*        currentValue={totalGain}*/}
            {/*        initialValue={totalValue - maxGains}*/}
            {/*        athValue={maxGains}*/}
            {/*        athDate={maxGainsDate}*/}
            {/*    >*/}
            {/*        {maxGains < 0 ? 'Loss' : 'Return'} ATH*/}
            {/*    </AllTimeHighBarometer>*/}
            {/*    {isRateCardVisible &&*/}
            {/*    <AllTimeHighBarometer*/}
            {/*        currentValue={assetRate}*/}
            {/*        athValue={maxRate}*/}
            {/*        athDate={maxRateDate}*/}
            {/*        rateChange={maxRate - assetRate}*/}
            {/*        rateDate={assetRateDate}*/}
            {/*    >*/}
            {/*        Price ATH*/}
            {/*    </AllTimeHighBarometer>*/}
            {/*    }*/}
            {/*</div>*/}
            {/*<Visualization />*/}
        </div>
    )
}